/**
 * Custom error class for API failures.
 * Preserves HTTP status, status text, and the parsed response body
 * so callers can inspect and handle specific error scenarios.
 */
export class ApiError extends Error {
  status: number;
  statusText: string;
  body: unknown;

  constructor(status: number, statusText: string, body: unknown) {
    const message =
      typeof body === "object" && body !== null && "error" in body
        ? String((body as Record<string, unknown>).error)
        : `Request failed with status ${status}: ${statusText}`;

    super(message);
    this.name = "ApiError";
    this.status = status;
    this.statusText = statusText;
    this.body = body;
  }
}
